import { FILTER_OPTION_TYPE_SEPARATOR } from "~/modules/dtwin/constants";
import type { DtwinTypeOption } from "~/modules/dtwin/models/DtwinTypeOptions.interface";

/**
 * Return a string option value corresponding to a dtwin type option value which can be an array of model UIDs
 * @param dtwinTypeOption
 * @returns
 */
export function getFilterDtwinTypeOptionValue(
  dtwinTypeOption: DtwinTypeOption,
): string {
  return Array.isArray(dtwinTypeOption.value)
    ? dtwinTypeOption.value.sort().join(FILTER_OPTION_TYPE_SEPARATOR)
    : dtwinTypeOption.value;
}
